import React from 'react';
import { useNavigate } from 'react-router-dom';

import { SignUpForm } from '@/components/organisms/SignUpForm';
import { LoginLayout } from '@/components/templates/LoginLayout';

export const SignUpPage = () => {
  const navigate = useNavigate();

  const onSignupSuccess = () => {
    navigate('/signup-validation');
  };

  return (
    <LoginLayout>
      <SignUpForm onSuccess={onSignupSuccess} />
    </LoginLayout>
  );
};
